import React from 'react';

import {View, Panel, PanelHeader, Group, List, Cell, FormItem, ButtonGroup, Textarea} from '@vkontakte/vkui';

import {Button, FormLayout, FormLayoutGroup, Input} from '@vkontakte/vkui';
import CartApi from "./CartApi";
import IMask from "imask";
import axios from "axios";


class SendHelpForm extends React.Component {

    state = {
        phone: '',
        email: '',
        text: '',
        phoneError: '',
        emailError: '',
        textError: '',

    }

    constructor(props) {
        super(props);
    }


    onChange = (e, name) => {

        const val = e.target.value

        let data = {}

        data[name] = val

        this.setState(data)
    }

    componentDidMount() {
        const self = this
        let phoneInput = document.getElementById("help_phone_input");

        const phoneMask = new IMask(phoneInput, {
            mask: "+{7}(000)000-00-00",
        });

        function phoneInputHandler(e) {
            if (phoneMask.masked.isComplete) {
                self.setState({phoneValid: true})
            } else {
                self.setState({phoneValid: false})
            }
            self.setState({current_phone: phoneMask.unmaskedValue, value: e.target.value})
        }

        phoneInput.addEventListener('input', phoneInputHandler)
    }

    render() {
        return (
            <FormLayout title="Обращение в техподдержку">
                <FormLayoutGroup>
                    <FormItem status={this.state.phoneError ? 'error' : (this.state.phone ? "valid" : "default")}
                              bottom={this.state.phoneError}>
                        <Input type="phone" id="help_phone_input" placeholder="Телефон" onChange={e => this.onChange(e, 'phone')}/>
                    </FormItem>
                    <FormItem status={this.state.emailError ? 'error' : (this.state.email ? "valid" : "default")}
                              bottom={this.state.emailError}>
                        <Input type="email" placeholder="Email" onChange={e => this.onChange(e, 'email')}/>
                    </FormItem>

                    <FormItem status={this.state.textError ? 'error' : (this.state.text ? "valid" : "default")}
                              bottom={this.state.textError}>
                        <Textarea rows={6} placeholder="Текст обращения" onChange={e => this.onChange(e, 'text')}/>
                    </FormItem>

                    <FormItem>
                        <ButtonGroup stretched>
                            <Button onClick={() => this.goBack()} stretched mode="outline" size="l">Отмена</Button>
                            <Button onClick={() => this.sendEmail()} stretched size="l">Отправить</Button>
                        </ButtonGroup>
                    </FormItem>
                </FormLayoutGroup>
            </FormLayout>
        );
    }

    sendEmail = () => {

        let errors_ = 0;

        this.setState(
            {
                phoneError: '',
                emailError: '',
                textError: '',
            })

        if (!this.state.phone) {
            this.setState({phoneError: 'Необходимо указать телефон'})
            errors_++;
        }

        if (!this.state.email) {
            this.setState({emailError: 'Необходимо указать email'})
            errors_++;
        }
        const re = /^[a-z0-9\-\_\.]+@[a-z0-9\-\_]{1,15}\.[a-z]{2,8}$/i;

        if (!re.test(this.state.email.toLowerCase())) {
            this.setState({emailError: 'Укажите корректный email'})
            errors_++;
        }

        if (!this.state.text) {
            this.setState({textError: 'Необходимо указать текст обращения'})
            errors_++;
        }

        if(errors_ === 0){

            const body = new FormData()


            body.append("phone", this.state.phone)
            body.append("email", this.state.email)
            body.append("body", this.state.text)
            body.append("username", '')


            axios.post(this.props.base_url + '/?act=sendHelpForm', body,
                {
                    withCredentials: true

                }
            ).then((response) => {

                if(response.data.success){
                    window.postMessage({type: 'success', text: 'Сообщение успешно отправлено', timeout: 2000});
                    this.goBack()

                } else {
                    window.postMessage({type: 'error', text: 'Возникла ошибка при отправке сообщения', timeout: 2000})
                }
            })
        }


    }
    goBack = () => {
        if (this.props.goBack) {
            this.props.goBack()
        }
    }
}

export default SendHelpForm

